const PIXEL_ID = '909790032056704'

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  // Load fbevents.js dynamically
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Initialize fbq
  const w = window as any
  if (w.fbq) return
  const n: any = (w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Init pixel and fire PageView
  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')

  // Noscript fallback
  const noscriptImg = document.createElement('img')
  noscriptImg.height = 1
  noscriptImg.width = 1
  noscriptImg.style.display = 'none'
  noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(noscriptImg)
}

export function trackAddToCart() {
  const w = window as any
  if (typeof w.fbq === 'function') {
    w.fbq('track', 'AddToCart', {
      content_name: 'The Debt-Free System',
      content_type: 'product',
      value: 9.99,
      currency: 'USD',
    })
  }
}
